export default function AddressCard({
    address,
    isSelected = false,
    onSelect,
    onEdit,
    onDelete,
    onSetDefault,
    showActions = true,
    selectable = false,
}) {
    const labelColors = {
        Home: 'bg-blue-50 text-blue-700',
        Office: 'bg-purple-50 text-purple-700',
        Other: 'bg-muted text-foreground/80',
    };

    const handleClick = () => {
        if (selectable && onSelect) {
            onSelect();
        }
    };

    return (
        <div
            onClick={handleClick}
            className={`relative bg-card rounded-lg border-2 p-4 transition-all ${
                selectable ? 'cursor-pointer hover:shadow-md' : ''
            } ${
                isSelected
                    ? 'border-primary ring-1 ring-primary/20 shadow-sm'
                    : 'border-border'
            }`}
        >
            {/* Badges row */}
            <div className="flex items-center gap-2 mb-3">
                {address.label && (
                    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${labelColors[address.label] || labelColors.Other}`}>
                        <i className={`${
                            address.label === 'Home' ? 'ri-home-4-line' :
                            address.label === 'Office' ? 'ri-building-line' :
                            'ri-map-pin-line'
                        } text-xs`}></i>
                        {address.label}
                    </span>
                )}
                {address.isDefault && (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-green-50 text-green-700">
                        <i className="ri-check-line text-xs"></i>
                        Default
                    </span>
                )}
                {isSelected && (
                    <span className="ml-auto">
                        <i className="ri-checkbox-circle-fill text-primary text-lg"></i>
                    </span>
                )}
            </div>

            {/* Address details */}
            <div className="space-y-1">
                <p className="text-sm font-semibold text-foreground">{address.fullName}</p>
                {address.phone && (
                    <p className="text-sm text-muted-foreground flex items-center gap-1.5">
                        <i className="ri-phone-line text-xs"></i>
                        {address.phone}
                    </p>
                )}
                <p className="text-sm text-muted-foreground">
                    {address.addressLine1}
                    {address.addressLine2 && `, ${address.addressLine2}`}
                </p>
                <p className="text-sm text-muted-foreground">
                    {[
                        address.cityName || address.city?.name,
                        address.stateName || address.state?.name,
                        address.countryName || address.country?.name,
                    ].filter(Boolean).join(', ')}
                </p>
                {address.postalCode && (
                    <p className="text-sm text-muted-foreground">Postal Code: {address.postalCode}</p>
                )}
            </div>

            {/* Action buttons */}
            {showActions && (
                <div className="flex items-center gap-3 mt-4 pt-3 border-t border-border">
                    {onEdit && (
                        <button
                            onClick={(e) => { e.stopPropagation(); onEdit(); }}
                            className="flex items-center gap-1 text-sm text-muted-foreground hover:text-primary transition-colors"
                        >
                            <i className="ri-edit-line text-sm"></i>
                            Edit
                        </button>
                    )}
                    {onDelete && (
                        <button
                            onClick={(e) => { e.stopPropagation(); onDelete(); }}
                            className="flex items-center gap-1 text-sm text-muted-foreground hover:text-red-600 transition-colors"
                        >
                            <i className="ri-delete-bin-line text-sm"></i>
                            Delete
                        </button>
                    )}
                    {onSetDefault && !address.isDefault && (
                        <button
                            onClick={(e) => { e.stopPropagation(); onSetDefault(); }}
                            className="flex items-center gap-1 text-sm text-muted-foreground hover:text-green-600 transition-colors ml-auto"
                        >
                            <i className="ri-checkbox-circle-line text-sm"></i>
                            Set as Default
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}
